if(!customElements.get('testimonials-section')) {
  class ComponentTestimonials extends HTMLElement {
    constructor() {
      super();

      this.showBtn = this.querySelector('.show-more');
      this.currentShow = 1;
      this.toShow = this.getToShow();
     
      this.showBtn.addEventListener('click', ()=>{
        $s.expand([this.toShow]);
        this.currentShow++;
        this.toShow = this.getToShow();
        if(!this.toShow)
          this.showBtn.classList.add("hide");
      })
    }

    getToShow(){
      return this.querySelector(`.more_estimonials_${this.currentShow}`);
    }


  }
  customElements.define('testimonials-section', ComponentTestimonials);
}